// eslint-disable-next-line no-shadow
export enum SubscriptionStatus {
  SUBSCRIBED = 'SUBSCRIBED',
  CANCELLED_STILL_ACTIVE = 'CANCELLED_STILL_ACTIVE',
  ENDED = 'ENDED',
}
